import React, { Component } from "react";
import { observer } from "mobx-react";

import { distinct } from "@formant/core/common/distinct";

import { IMultiSelectOption, MultiSelect } from "../common/MultiSelect";

export interface ITagSelectProps {
    value: string[];
    tagKey: string;
    options: string[];
    className?: string;
    onChange: (tagKey: string, value: string[]) => void;
}

@observer
export class TagSelect extends Component<ITagSelectProps> {
    public render() {
        const { value, tagKey, className } = this.props;
        const options = distinct([...this.props.options, ...value])
            .sort()
            .map<IMultiSelectOption<string>>(tag => ({
                value: tag,
                icon: "tags",
                label: tag === "" ? "None" : undefined,
            }));
        if (tagKey.startsWith("$.") || options.length === 0) {
            return false;
        }
        const disabled = value.length === 0 && options.length === 1;
        return (
            <MultiSelect
                value={value}
                title={tagKey}
                options={options}
                className={className}
                onChange={this.onChange}
                disabled={disabled}
            />
        );
    }

    private onChange = (value: string[]) => {
        const { tagKey, onChange } = this.props;
        onChange(tagKey, value);
    };
}
